<div>
  @for (_ of entrypoints; track trackByIndex($index); let idx = $index) {
    <div class="multiline-text-entry__entry-row">
      <mat-form-field class="multiline-text-entry__form-field">
        <input
          matInput
          type="text"
          id="entry-{{ idx }}"
          [(ngModel)]="entrypoints[idx]"
          [maxlength]="LIMITS.CATALOG_ENTRY"
          (change)="handleChange(idx, entrypoints[idx])"
        />
      </mat-form-field>

      <div class="multiline-text-entry__button-group">
        <button mat-icon-button color="primary" (click)="moveUp(idx)" [disabled]="idx === 0"
                class="multiline-text-entry__button">
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="moveDown(idx)" [disabled]="idx === entrypoints.length - 1"
                class="multiline-text-entry__button">
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="remove(idx)" class="multiline-text-entry__button">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  }

  <div class="multiline-text-entry__add-entry">
    <mat-form-field class="multiline-text-entry__add-form-field">
      <mat-label>{{ 'personalData.multilineTextEntry.newEntry' | translate }}</mat-label>
      <textarea
        matInput
        rows="3"
        [(ngModel)]="newEntry"
        [maxlength]="LIMITS.CATALOG_ENTRY"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="addNew()"
      ></textarea>
      <mat-hint align="end">{{ (newEntry?.length || 0) }}/{{ LIMITS.CATALOG_ENTRY }}</mat-hint>
    </mat-form-field>

    <button mat-mini-fab color="accent" (click)="addNew()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>

